import { Injectable, Signal, inject } from '@angular/core';
import { APP_ACTIONS, type AppActionsApi } from '@app/core/app.actions';
import { RxState } from '@rx-angular/state';
import { Bunker } from '@vessel-reports/port/state/port.types';

interface IPortState {
  detailPortReport: any;
  previousReport: any;
  inventories: any[];
  detailBunker: Bunker;
  types: any[];
  voyages: any[];
  dateReport: any;
  ports: any[];
}

@Injectable({
  providedIn: 'root'
})
export class PortState extends RxState<IPortState> {
  protected readonly appActions: AppActionsApi = inject(APP_ACTIONS);

  detailPortReport: Signal<any> = this.signal('detailPortReport');
  previousReport: Signal<any> = this.signal('previousReport');
  detailBunker: Signal<Bunker> = this.signal('detailBunker');
  types: Signal<any> = this.signal('types');
  voyages: Signal<any> = this.signal('voyages');
  dateReport: Signal<any> = this.signal('dateReport');
  ports: Signal<any> = this.signal('ports');

  constructor() {
    super();
    this.hold(this.appActions.resetAll$, () => {
      this.reset();
    });
    this.set({
      detailPortReport: null,
      previousReport: null,
      inventories: [],
      detailBunker: null,
      ports: []
    });
  }

  // Clear all port report related state
  reset(): void {
    this.set({
      detailPortReport: null,
      previousReport: null,
      inventories: [],
      detailBunker: null,
      types: [],
      voyages: [],
      dateReport: null,
      ports: []
    });
  }
}
